import { formatDateTime } from "@clipboard-health/date-time";
import { type ProfileChangeLog } from "@clipboard-health/contract-backend-main";
import {
  Divider,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { type ReactNode } from "react";

import { PLACEHOLDER } from "./constants";
import { transformLogsToTableRows, type UpdatedField } from "./helpers";
import { UpdatedFieldContainer } from "./UpdatedFieldContainer";

interface ProfileChangeLogsTableProps {
  logs: ProfileChangeLog[];
}

export function ProfileChangeLogsTable(props: ProfileChangeLogsTableProps) {
  const rows = transformLogsToTableRows(props.logs);

  return (
    <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: "bold", minWidth: 160 }}>Datetime</TableCell>
            <TableCell sx={{ fontWeight: "bold", minWidth: 120 }}>Update Type</TableCell>
            <TableCell sx={{ fontWeight: "bold", minWidth: 90 }}>Action</TableCell>
            <TableCell sx={{ fontWeight: "bold", minWidth: 200 }}>Context</TableCell>
            <TableCell sx={{ fontWeight: "bold", minWidth: 320 }}>Updated Fields</TableCell>
            <TableCell sx={{ fontWeight: "bold", minWidth: 120 }}>Performed By</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            return (
              <TableRow key={row.id} hover>
                <TableCell sx={{ verticalAlign: "top" }}>{formatDateTime(row.datetime)}</TableCell>
                <TableCell sx={{ verticalAlign: "top" }}>{row.updateType}</TableCell>
                <TableCell sx={{ verticalAlign: "top" }}>{row.action}</TableCell>
                <TableCell sx={{ verticalAlign: "top" }}>{row.context}</TableCell>
                <TableCell sx={{ verticalAlign: "top" }}>
                  {renderUpdatedFieldsCell(row.updatedFields)}
                </TableCell>
                <TableCell sx={{ verticalAlign: "top", wordBreak: "break-word" }}>
                  {row.performedBy}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function renderUpdatedFieldsCell(fields: UpdatedField[]): ReactNode {
  if (fields.length === 0) {
    return PLACEHOLDER;
  }

  return (
    <Stack spacing={2} divider={<Divider flexItem />}>
      {fields.map((field) => (
        <UpdatedFieldContainer
          key={field.key}
          fieldKey={field.key}
          previousValue={field.previousValue}
          newValue={field.newValue}
        />
      ))}
    </Stack>
  );
}
